export default {
    title: 'Kategorie verknüpfen',
    attachCategoryText: 'Welche Kategorie möchtest du mit den ausgewählten Organisationen verknüpfen?'
}